import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
//import { ObjectLoader } from './three.module';
import * as THREE from "three";

import { ObjectLoader } from "three";

export default class Pista {
  constructor(f, scene) {
    this.scene = scene;
    this.despues = f;
    this.objetos = [];
    this.imagen = new Image();
    this.colision = new Image();
    this.mapa = [];
    this.canvas = document.createElement('canvas');
    this.canvas2 = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.ctxColision = this.canvas2.getContext('2d');
  }

  objeto(nombre, tipo, func, valor, permanente) {
    var loader;
    const extension = nombre.split(".").pop()

    //    console.log('objeto',nombre);
    this.objetos[tipo] = false;

    var objetos = this.objetos;
    switch (extension) {
      case 'gltf':
      case 'glb':
        loader = new GLTFLoader();
        break;
      case 'json':
        loader = new ObjectLoader();
        break;
      default:
        loader = new OBJLoader();
    }

    loader.load(nombre,
      //      function ( obj ) {objetos[tipo]={tipo:tipo,nombre: nombre,obj: obj};},
      function (obj) {
        // eslint-disable-next-line no-array-constructor
        let modeloFinal;

        if (extension === 'gltf' || extension === 'glb') {
          modeloFinal = obj.scene;   // 🔥 importante
        } else {
          modeloFinal = obj;
        }

        objetos[tipo] = [tipo, nombre, modeloFinal, permanente];
        func(valor);
      },

      function (xhr) {//console.log( (nombre+':'+xhr.loaded / xhr.total * 100) + '% cargado' );
      },
      function (err) { console.error('Un error ocurrio'); }
    );
  }

  cargarSuelo(pistaArchivo, colisionArchivo) {
    this.cargarColision(colisionArchivo);
    this.cargarPista(pistaArchivo);
  }

  cargarPista(nombre) {
    var ppal = this;
    //    async function delay(delayInms) {
    //      return new Promise(resolve  => {
    //        setTimeout(() => {resolve(2);}, delayInms);
    //      });
    //    }
    this.imagen.onload = function () {
      ppal.canvas.width = this.width;
      ppal.canvas.height = this.height;
      ppal.ctx.drawImage(this, 0, 0);
      //      async function continua() {
      //        while (!ppal.objetos.every(e=>e!==false)){await delay(1000);}
      //        ppal.procesar(ppal);
      //      }
      //      continua();
      setTimeout(() => {
        ppal.procesar(ppal);
      }, 1000);

    }
    this.imagen.src = nombre;
  }
  cargarColision(nombre) {
    console.log('Plano de colision:', nombre);

    const ppal = this;

    this.colision.onload = function () {

      const ancho = this.width;
      const alto = this.height;



      // Ajustar canvas al tamaño de la imagen (MUY recomendable)
      ppal.canvas2.width = ancho;
      ppal.canvas2.height = alto;


      ppal.ctxColision.drawImage(this, 0, 0);

    };

    this.colision.src = nombre;
  }

  hayColision(x, y) {
    return this.ctxColision.getImageData(x, y, 1, 1).data[0];
  }

  procesar(armar) {
    //    console.log(this.scene);
    //console.log('procesando...');

    const ancho = armar.imagen.width;
    const alto = armar.imagen.height;

    const imageData = armar.ctx.getImageData(0, 0, ancho, alto);
    const data = imageData.data; // Uint8ClampedArray

    armar.mapa = [];

    for (let y = 0; y < alto; y++) {
      for (let x = 0; x < ancho; x++) {

        const index = (y * ancho + x) * 4;

        const r = data[index];     // rojo
        const g = data[index + 1]; // verde
        const b = data[index + 2]; // azul
        const a = data[index + 3]; // alpha

        if (r !== 0xff && r !== 0x00) {
          // console.log(r);
          armar.mapa.push({
            x,
            y,
            codigo: r,
            rotacion: g
          });
        }
      }
    }

    /*armar.mapa.forEach(e => {
      //console.log(e);
      if (!armar.objetos[e["codigo"]]) {
        //console.log (e)
      }
      else {
        var o = (armar.objetos[e["codigo"]][2]).clone();
        o.name = armar.objetos[e["codigo"]][1];
        o.permanente =

          o.translateZ(e["y"] * 3);
        o.translateX(e["x"] * 3);

        if (e["rotacion"] !== 0) {
          o.rotateY((e["rotacion"] / 255) * (2 * Math.PI));
        }
        o.visible = true;
        o.permanente = armar.objetos[e["codigo"]][3];
        this.scene.add(o);
      }
    });*/


    const objetos = armar.objetos;
    const mapa = armar.mapa;

    for (let i = 0; i < mapa.length; i++) {

      const e = mapa[i];
      const objData = objetos[e.codigo];

      if (!objData) continue;

      const o = objData[2].clone();

      o.name = objData[1];

      o.position.set(
        e.x * 3,
        0,
        e.y * 3
      );

      if (e.rotacion !== 0) {
        o.rotation.y = (e.rotacion / 255) * (2 * Math.PI);
      }

      o.visible = true;
      o.permanente = objData[3];

      this.scene.add(o);
    }



    //console.log(armar.scene.children);
    requestAnimationFrame(armar.despues);
  }
}